import moment from 'moment-timezone';

//Structure of dynamic filters
export const FielsFilter = (langPlace, name, value, props) => {
  const Description = langPlace.names

  const title = Description[name]
  let array = undefined
  let isError = false
  let result = {isError: false}

  switch (name.toUpperCase()) {
    case 'SECONDSURNAME':
      break;
    case 'EMAIL':
      let text1 = langPlace.errors.heisrequired.replace('XXX', title.toLowerCase())
      array = [ {filter: isEmpty, values: { value: value }, message: text1},
                {filter: validateEmail, values: { email: value }, message: `${langPlace.errors.incorrectformat}`} ]
      break;
    case 'REPEATEMAIL':
      let text2 = langPlace.errors.heisrequired.replace('XXX', title.toLowerCase())
      array = [ {filter: isEmpty, values: { value: value }, message: text2},
                {filter: repeat, values: {objA: value, objB: props['email']}, message: langPlace.errors.duplicatemail} ]
      break;
    case 'BRAND':
    case 'DISPLACEMENT':
    case 'LICENSEPLATE':
    case 'NATIONALITY':
      let text3 = langPlace.errors.sheisrequired.replace('XXX', title.toLowerCase())
      array = [ {filter: isEmpty, values: { value: value }, message: text3} ]
      break;
    case 'BIRTHDATE':
      let text4 = langPlace.errors.sheisrequired.replace('XXX', title.toLowerCase())
      array = [ {filter: isEmpty, values: { value: value }, message: text4},
                {filter: validateDate, values: { str: value }, message: `${langPlace.errors.incorrectformatdate}`} ]
      break;
    case 'POSTALCODE':
      let text5 = langPlace.errors.heisrequired.replace('XXX', title)
      array = [ {filter: isEmpty, values: { value: value }, message: text5} ]
      break;
    default:
      let text6 = langPlace.errors.heisrequired.replace('XXX', title.toLowerCase())
      array = [ {filter: isEmpty, values: { value: value }, message: text6} ]
      break;
  }

  if (array !== undefined){
    array.forEach(function(item) {
      if (isError === false){
        let {filter, values, message} = item
        isError = filter({...values})
        if (isError){
          result = {isError: true, message: message}
        }
      }
    })
  }

  return (result)
}

//Filters of all fields in the forms
const isEmpty = ({value}) => {
  return ((value===undefined)? true: (value.length === 0)? true: false)
}

const repeat = ({objA, objB}) => {
  return (objA !== objB)
}

const validateEmail = ({ email }) => {
    var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return (!re.test(email))
}

const validateDate = ({ str }) => {
  if (typeof str !== 'string') {
    return false;
  }

  const d = moment(str, 'D/M/YYYY');
  if (d == null || !d.isValid()) {
    return false;
  }

  const isValidDate = str.indexOf(d.format('D/M/YYYY')) >= 0
                   || str.indexOf(d.format('DD/MM/YYYY')) >= 0;

  return !isValidDate;
}



// WEBPACK FOOTER //
// ./src/shared/routes/routeData/functions.js